const WORDS = [
  "Discipline",
  "Clarity",
  "Patience",
  "Resilience",
  "Knowledge",
  "Responsibility",
  "Consistency",
  "Humility",
];

// Slow editorial marquee ribbon separating major sections.
export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="relative border-y border-white/10 bg-ink-soft/40 py-8 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-4xl md:text-6xl text-bone/90 px-8">{w}</span>
            <span className="h-2 w-2 rounded-full bg-gold" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ink to-transparent" />
    </div>
  );
};
